import { useLocation, useNavigate, useParams } from "react-router";
import { useReviews } from "hooks/LabelPropagation/useGetReview";
import { CLUSTER_DETAILS_PAGE, DATA_PAGE } from "helpers/constants/pages";
import DataList from "../DataList";
import {
  FLOW_PARAMETER,
  LABEL_CLASS_PARAMETER,
} from "helpers/constants/miscellaneous";
import { useMemo, useCallback } from "react";
import ClusterDetailsFilter from "../DataPageFilters/ClusterDetailsFilter";

interface ReviewListProps {
  onReviewAction: (sampleId?: string) => void;
}
export default function ReviewList({ onReviewAction }: ReviewListProps) {
  const { datasetId, clusterId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const flowId = searchParams.get(FLOW_PARAMETER);
  const labelId = searchParams.get(LABEL_CLASS_PARAMETER);

  const { reviews, selectedReview } = useReviews(
    onReviewAction,
    datasetId,
    flowId,
    labelId
  );

  const clusterLabel = useMemo(() => {
    if (!selectedReview) return undefined;

    return {
      text: selectedReview.label,
      onClick: () => {
        const params = new URLSearchParams(location.search);
        params.delete(LABEL_CLASS_PARAMETER);
        navigate({ search: `?${params.toString()}` });
      },
      tooltip: "Click to go back",
    };
  }, [selectedReview, location.search, navigate]);

  const handleLabelClick = useCallback((value: string[]) => {}, []);

  const showClusterFilter = (!!clusterId || !!labelId) && !!datasetId;

  const limitedPreviewReviews = (reviews || []).map((review) => ({
    ...review,
    previews: review.previews?.slice(0, 9) ?? [],
  }));

  return (
    <DataList
      page={labelId ? CLUSTER_DETAILS_PAGE : DATA_PAGE}
      clusters={limitedPreviewReviews || []}
      navigationCluster={labelId ? selectedReview : undefined}
      navigationClusterTags={undefined}
      isContentLoading={!reviews}
      showMetadataSummary={true}
      labelPropagation={{
        isLabelPropagationEnabled: true,
        onLabelClick: handleLabelClick,
      }}
      isDataPage={!!datasetId && !labelId}
      rightPanelMode="labels"
      title={{
        text: "Review",
        icon: showClusterFilter ? (
          <ClusterDetailsFilter label={clusterLabel} />
        ) : undefined,
      }}
    />
  );
}
